
import { Injectable } from '@angular/core';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { DashboardApiResponse } from '../models/dashboard.model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  baseUrl = 'Dashboard';
  constructor(private httpCommonService: HttpCommonService) {
  }

  getDashboard(): Observable<DashboardApiResponse> {
    return this.httpCommonService.get<DashboardApiResponse>({ url: this.baseUrl + "/Get" });
  }


}
